import { axiosInstance } from '../axios/axiosConfig';

const baseAPIUrl = "LandingEvents";

export async function getEvents(pagingRequest, filters) {
  return await axiosInstance.post(`/${baseAPIUrl}/paged`, {
    ...pagingRequest,
    filters
  });
}

export async function getEventDetail(eventId) {
  return await axiosInstance.get(`/${baseAPIUrl}/${eventId}`);
}